import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { getProduct } from "@/lib/products";
import AgenteConnect from "@/pages/AgenteConnect";

export const Route = createFileRoute("/agente-connect")({
  head: () => buildHead({
    title: `${getProduct("agente-connect")!.name} — OP2P CRM e Agentes de IA`,
    description: `${getProduct("agente-connect")!.tagline} ${getProduct("agente-connect")!.description}`,
    path: "/agente-connect",
  }),
  component: AgenteConnect,
});
